import axios from 'services/axios';
import { API } from 'services/constants';
import { ChargeDeviceChipChange } from '../actions';

const createAction = name => ({
  GET_DEVICE_PENDING: `${name}_GET_DEVICE_PENDING`,
  GET_DEVICE_SUCCESS: `${name}_GET_DEVICE_SUCCESS`,
  GET_DEVICE_FAILED: `${name}_GET_DEVICE_FAILED`
});

export const DEVICE = createAction('DEVICE');

export const GetDeviceFilter = () => async (dispatch, getState) => {
  dispatch({ type: DEVICE.GET_DEVICE_PENDING });
  try {
    const { branchChips } = getState().charge;

    let branchIdList = [];

    branchChips.forEach(branchChip => {
      branchIdList = [...branchIdList, branchChip.id];
    });

    const params = { branchIdList };

    const result = await axios
      .post(API.POST_DEVICE_FILTER, params)
      .then(res => res.data[0])
      .catch(err => Promise.reject(err));

    dispatch({
      type: DEVICE.GET_DEVICE_SUCCESS,
      payload: typeof result !== 'undefined' ? result : []
    });

    dispatch(ChargeDeviceChipChange(typeof result !== 'undefined' ? result : []));
  } catch (error) {
    dispatch({
      type: DEVICE.GET_DEVICE_FAILED,
      error
    });
  }
};
